import React, { useEffect } from 'react'
import { formatDate, usePathParam, useViewport } from '@chilecompra/react-kit'
import { batch, useSelector, useDispatch } from 'react-redux'
import { DataTable, Skeleton, Typography, Spinner } from '@chilecompra/react-kit/components'
import {
  PUBLIC_URL,
  REACT_APP_COURT_URL,
  REACT_APP_FEATURE_FLAG_COURT_REDIRECT_BOX
} from '../../config/settings/environment'
import { exportToExcel } from '../../modules/utils/exports'
import { onGetTotalDemandsThunk, onGetLisOfDemandsThunk } from './PublicProcurementCourtClaimsSection.actions'
import {
  ArrowDownIcon,
  ArrowForwardIcon,
  Card,
  CardItem,
  Column,
  Link,
  NotFoundImg,
  Root,
  Row,
  Strong,
  SummaryCard,
  TableContainer,
  TableLink,
  WarningImg
} from './PublicProcurementCourtClaimsSection.styles'

/**
 * The public procurement court claims section container.
 */
const PublicProcurementCourtClaimsSection = () => {
  const {
    size: { isUpToMedium, isTiny }
  } = useViewport()
  const { error, loading, initialDate, finalDate, listOfDemands, excelData, totalDemands, loadingSpinner } =
    useSelector(state => state.publicProcurementCourtClaims)
  const dni = usePathParam('rut')
  const getCurrentDate = new Date()
  const dispatch = useDispatch()

  const totalRows = 10
  const hasData = listOfDemands?.length > 0
  const handleDownload = () => {
    exportToExcel(excelData, 'Demandas')
  }

  const handleKeyPressDownload = event => {
    if (event.charCode === 13 || event.charCode === 32) {
      event.preventDefault()
      handleDownload()
    }
  }

  const gettingMonthAndYear = date => {
    const aux = new Date(date)
    const optionMonth = { month: 'long' }
    const month = aux.toLocaleString('es-ES', optionMonth)
    const year = aux.getFullYear()
    const result = { month, year }
    return result
  }

  useEffect(() => {
    batch(() => {
      dispatch(onGetTotalDemandsThunk(dni))
      dispatch(onGetLisOfDemandsThunk(dni))
    })
  }, [])

  const handleDetailsCourt = url => () => {
    if (!url) return

    window.open(url, 'Ficha_Compra')
  }

  const handleKeyPress = url => event => {
    if (event.charCode === 13 || event.charCode === 32) {
      event.preventDefault()

      if (!url) return

      window.open(url, 'Ficha_Compra')
    }
  }

  const handleRole = (role, date) => () => {
    const [, , year] = date.split('-')
    // const formatedDate = new Date(`${year}-${month}-${day}`)

    const folio = role?.split('-')[0]
    // const year = new Date(formatedDate).getFullYear()

    console.log({ folio, year })
    console.log(`${REACT_APP_COURT_URL}&folio=${folio}&era=${year}`)

    window.open(`${REACT_APP_COURT_URL}&folio=${folio}&era=${year}`, '_blank', 'noopener,noreferrer')
  }

  const handleKeyPressRole = (role, date) => event => {
    if (event.charCode === 13 || event.charCode === 32) {
      event.preventDefault()
      handleRole(role, date)()
    }
  }

  return (
    <Root>
      {loading ? (
        <Row flexDirection="column" gap="5px">
          <Skeleton height="35px" variant="rectangular" width="65%" />
          <Skeleton height="15px" variant="rectangular" width="60%" />
          <Skeleton height="35px" variant="rectangular" width="70%" />
        </Row>
      ) : (
        <Row margin="10px 0 8px 0px" flexDirection="column">
          <Typography color="black1" variant="h4" fontWeight="bold" fontSize="18px" lineHeight="22px" tabIndex="0">
            Acciones interpuestas ante el Tribunal de Contratación Pública
          </Typography>
          <Typography
            color="black3"
            display="inline"
            variant="body2"
            fontWeight="regular"
            fontSize="14px"
            lineHeight="18px"
            tabIndex="0"
          >
            <Strong>Fuente:</Strong>Tribunal de Contratación Pública (https://tribunaldecontratacionpublica.cl)
          </Typography>
        </Row>
      )}

      {!error && !loading && hasData && (
        <Row>
          <Column width={isUpToMedium ? '70%' : '100%'}>
            <Typography
              color="black1"
              variant="body1"
              fontWeight="regular"
              fontSize="16px"
              lineHeight="21px"
              tabIndex="0"
              margin="24px 0 0 0"
            >
              Revisa las demandas que ha recibido este organismo comprador durante el periodo de{' '}
              <strong>
                {gettingMonthAndYear(initialDate).month} {gettingMonthAndYear(initialDate).year} a{' '}
                {gettingMonthAndYear(finalDate).month} {gettingMonthAndYear(finalDate).year}.
              </strong>
            </Typography>
          </Column>
        </Row>
      )}

      {error && (
        <Card
          display="flex"
          enableBorder
          color="blank"
          margin="43px 0 44px 0"
          alignItems="center"
          height={isTiny ? '139px' : '243px'}
        >
          <CardItem direction="row" padding="25px 16px">
            <WarningImg alt="No se encontraron resultados" src={`${PUBLIC_URL}/assets/images/warning.svg`} />
            <Typography
              color="black1"
              variant="body1"
              fontWeight="regular"
              fontSize="14px"
              lineHeight="18px"
              margin="0 0 0 33px"
              tabIndex="0"
            >
              No ha sido posible obtener información de la institución.
              <br />
              Por favor, te pedimos que lo vuelvas a intentar dentro de unos minutos.
            </Typography>
          </CardItem>
        </Card>
      )}

      {!error && !hasData && (
        <Card
          margin="24px 0 39px 0"
          display="flex"
          color="blank"
          enableBorder
          textAlign="center"
          sx={{ border: '1px solid blue' }}
        >
          <CardItem flexDirection="column">
            <NotFoundImg
              alt="No se encontraron resultados"
              margin="48px 0 0 0"
              src={`${PUBLIC_URL}/assets/images/notFound.svg`}
            />
            <Typography
              color="black1"
              variant="h4"
              fontWeight="bold"
              fontSize="18px"
              lineHeight="22px"
              margin="10px 0 0 0"
              tabIndex="0"
            >
              No existe información
            </Typography>
            <Typography
              color="black3"
              display="inline"
              fontWeight="regular"
              fontSize="14px"
              margin="0 0 48px 0"
              variant="subtitle"
              lineHeight="18px"
            >
              El organismo comprador no ha recibido
              <br />
              demandas durante los últimos 12 meses.
            </Typography>
          </CardItem>
        </Card>
      )}

      {!error && hasData && (
        <>
          <SummaryCard
            enableBorder
            margin="24px 0 29px 0"
            display="flex"
            color="blank"
            maxWidth="508px"
            padding="18px 26px 14px 25px"
          >
            <Row flexWrap="nowrap">
              <Column display="flex" justifyContent="center">
                {loading ? (
                  <Skeleton height="35px" margin="10px 10px 0 0" variant="rectangular" width="80px" />
                ) : (
                  <Typography
                    color="black1"
                    variant="h2"
                    fontWeight="bold"
                    fontSize="27px"
                    lineHeight="31px"
                    margin="10px 10px 5px"
                    tabIndex="0"
                  >
                    {totalDemands}
                  </Typography>
                )}
              </Column>

              <Column lg={9} sm={8} xs={7} alignContent="initial">
                <Row>
                  {loading ? (
                    <Skeleton height="21px" margin="5px 0 0 0" variant="rectangular" width="100%" />
                  ) : (
                    <Typography
                      color="black1"
                      fontSize="18px"
                      fontWeight="bold"
                      lineHeight="21px"
                      tabIndex="0"
                      variant="body1"
                      margin="10px 10px 0 0"
                    >
                      Demandas recibidas
                    </Typography>
                  )}
                </Row>
                <Row>
                  {loading ? (
                    <Skeleton height="21px" margin="5px 0 0 0" variant="rectangular" width="100%" />
                  ) : (
                    <Typography
                      color="black1"
                      variant="body1"
                      fontWeight="regular"
                      fontSize="18px"
                      lineHeight="21px"
                      tabIndex="0"
                    >
                      Entre {gettingMonthAndYear(initialDate).month} {gettingMonthAndYear(initialDate).year} y{' '}
                      {gettingMonthAndYear(finalDate).month} {gettingMonthAndYear(finalDate).year}
                    </Typography>
                  )}
                </Row>
                <Row>
                  {loading ? (
                    <Skeleton height="15px" margin="5px 0 0 0" variant="rectangular" width="100%" />
                  ) : (
                    <Typography
                      color="black3"
                      display="inline"
                      fontWeight="regular"
                      fontSize="14px"
                      variant="body2"
                      lineHeight="18px"
                      tabIndex="0"
                    >
                      Información actualizada al {formatDate(getCurrentDate, 'dd-MM-yyyy')}
                    </Typography>
                  )}
                </Row>
              </Column>

              <Column lg={2} sm={2} xs={3}>
                {loading ? (
                  <Skeleton height="80px" margin="0 5px" variant="rectangular" width="80px" />
                ) : (
                  <NotFoundImg alt="img error" src={`${PUBLIC_URL}/assets/images/magnifying_glass_icon.svg`} />
                )}
              </Column>
            </Row>
          </SummaryCard>

          {loading ? (
            <Skeleton height="674px" variant="rectangular" width="100%" />
          ) : (
            <>
              <Card enableBorder margin="24px 0 50px 0" display="flex" color="blank">
                {loadingSpinner ? (
                  <CardItem direction="row" sx={{ margin: '97px auto' }}>
                    <Spinner />
                  </CardItem>
                ) : (
                  <>
                    <TableContainer>
                      <DataTable
                        accessibility={{ label: 'Tabla detalles de demandas recibidas' }}
                        header={
                          <Typography
                            color="black1"
                            display="inline"
                            variant="h4"
                            fontWeight="bold"
                            fontSize="18px"
                            lineHeight="22px"
                            align="left"
                            tabIndex="0"
                          >
                            Detalle de demandas recibidas
                          </Typography>
                        }
                        enablePagination
                        showPagination
                        enableResults
                        loading={loading}
                        headers={[
                          { label: 'ROL', value: 'ROLE' },
                          { label: 'Proceso de compra', value: 'process' },
                          { label: 'Fecha de ingreso', value: 'date' },
                          { label: 'Demandante', value: 'demanding' }
                        ]}
                        headersCellsProps={[
                          { enableSort: false, width: '166px', enableFilter: true },
                          { enableSort: false, width: '211px', enableFilter: true },
                          { enableSort: false, width: '174px', enableFilter: true },
                          { enableSort: false, width: '444px', enableFilter: true }
                        ]}
                        records={listOfDemands}
                        initialRows={totalRows}
                        recordsCellsProps={[
                          { alignment: 'left', verticalAlign: 'middle' },
                          { alignment: 'left', verticalAlign: 'middle' },
                          { alignment: 'left', verticalAlign: 'middle' },
                          { alignment: 'left', verticalAlign: 'middle' }
                        ]}
                        recordsDecorators={[
                          ({ ROLE, date }) => (
                            <TableLink
                              tabIndex="0"
                              target="_blank"
                              onClick={handleRole(ROLE, date)}
                              onKeyPress={handleKeyPressRole(ROLE, date)}
                              textDecoration="underline"
                              rel="noreferrer"
                            >
                              {ROLE}
                            </TableLink>
                          ),
                          ({ process, url }) => {
                            if (!url) return process

                            return (
                              <TableLink
                                tabIndex={0}
                                onClick={handleDetailsCourt(url)}
                                onKeyPress={handleKeyPress(url)}
                                target="_blank"
                                rel="noopener noreferrer"
                                textDecoration="underline"
                              >
                                {process}
                              </TableLink>
                            )
                          },
                          ({ date }) => date,
                          ({ demanding }) => demanding
                        ]}
                      />
                    </TableContainer>
                    <Link
                      tabIndex="0"
                      color="primary"
                      onClick={handleDownload}
                      onKeyPress={handleKeyPressDownload}
                      textDecoration="underline"
                    >
                      <ArrowDownIcon /> Descargar en excel
                    </Link>
                  </>
                )}
              </Card>
            </>
          )}
        </>
      )}

      {(REACT_APP_FEATURE_FLAG_COURT_REDIRECT_BOX === true || REACT_APP_FEATURE_FLAG_COURT_REDIRECT_BOX === 'true') && (
        <>
          {loading ? (
            <Card margin="24px 0 50px 0" display="flex" color="blank" width={isUpToMedium ? '50%' : '100%'}>
              <Skeleton height="25px" variant="rectangular" width="50%" />
              <Skeleton height="80px" variant="rectangular" width="100%" />
            </Card>
          ) : (
            <Card
              enableBorder
              margin="24px 0 50px 0"
              display="flex"
              color="blank"
              width={isUpToMedium ? '46%' : '100%'}
            >
              <Row margin="0 0 19px 0">
                <Typography
                  color="black1"
                  fontWeight="bold"
                  variant="h4"
                  fontSize="18px"
                  lineHeight="21px"
                  tabIndex="0"
                >
                  Todas las demandas recibidas
                </Typography>
              </Row>
              <Row>
                <Typography
                  color="black1"
                  fontWeight="regular"
                  variant="body1"
                  fontSize="16px"
                  lineHeight="21px"
                  tabIndex="0"
                >
                  Revisa el listado completo de demandas que haya recibido este organismo comprador ante el Tribunal de
                  Contratación Pública.
                </Typography>
              </Row>
              <Row margin="37px 0 1px 0" justifyContent="flex-end">
                <Link target="_blank" href={REACT_APP_COURT_URL} color="primary" display="inline" rel="noreferrer">
                  Ir al Tribunal de Contratación Pública
                  <ArrowForwardIcon />
                </Link>
              </Row>
            </Card>
          )}
        </>
      )}
    </Root>
  )
}

export default PublicProcurementCourtClaimsSection
